import { cva, type VariantProps } from 'class-variance-authority';
import { type ReactNode } from 'react';

import styles from '../components/HomeMetrics/homeMetrics.module.css';
const cardStyles = cva('overflow-hidden', {
	variants: {
		bg: {
			bgNone: '',
			default: 'bg-gray-40',
			highlight: 'bg-success-light',
			lightBlue: 'bg-mgo/10',
			white: 'bg-white',
			'white/80': 'bg-white/80',
			definedBlack: styles.definedBlack,
			definedMapBg: 'defined-map-bg', //地图背景颜色
		},
		height: {
			full: 'h-full',
		},
		width: {
			full: 'w-full',
		},
		rounded: {
			lg: 'rounded-lg',
			xl: 'rounded-xl',
			'2xl': 'rounded-2xl',
		},
		spacing: {
			none: '',
			sm: 'px-5 py-4',
			md: 'p-5',
			lg: 'p-6',
			lgGraph: 'p-6 pb-4',
		},
		border: {
			gray45: 'border border-gray-45',
			steel: 'border border-steel',
		},
		shadow: {
			true: 'shadow-cardSoft',
		},
		growOnHover: {
			true: 'hover:scale-101 ease-in-out duration-200',
		},
		grid: {
			true: 'grid grid-cols-rows',
		},
	},
	defaultVariants: {
		bg: 'default',
		spacing: 'md',
		rounded: 'xl',
	},
});

export interface CardProps extends VariantProps<typeof cardStyles> {
	children?: ReactNode;
}

export function Card({
	spacing,
	rounded,
	bg,
	border,
	shadow,
	children,
	height,
	width,
	grid,
	growOnHover,
}: CardProps) {
	return (
		<div
			className={cardStyles({
				spacing,
				rounded,
				bg,
				width,
				grid,
				border,
				shadow,
				height,
				growOnHover,
			})}
		>
			{children}
		</div>
	);
}
